import { AnyAction } from "redux";
import { PrepaidRefillState } from "../../../../../models/state";
import * as PREPAID_REFILL_AT from "../actionTypes";

export function fulfilled(actionType: keyof typeof PREPAID_REFILL_AT) {
    return `${actionType}_FULFILLED`;
}

export const initialState: PrepaidRefillState = {
    isPhoneNumberValid: false,
    selectedRefillOptionCodes: [],
    selectedRefillOptionNames: [],
    content: [],
    selectedPhoneNumber: "",
    isSubmitted: false,
};

const reducer = (state = initialState, action: AnyAction): PrepaidRefillState => {
    switch (action.type) {
        case fulfilled(PREPAID_REFILL_AT.PREPAID_REFILL_VERIFY_PHONE_NUMBER):
            return {
                ...state,
                isPhoneNumberValid: action.payload === "OK",
            };
        case fulfilled(PREPAID_REFILL_AT.PREPAID_REFILL_SET_REFILL_OPTION):
            return {
                ...state,
                selectedRefillOptionCodes: action.payload,
            };
        case fulfilled(PREPAID_REFILL_AT.PREPAID_REFILL_SUBMIT_ORDER): {
            return {
                ...state,
                isSubmitted: true,
            };
        }
        default:
            return state;
    }
};

export default reducer;
